(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('NivelesEducativosService', NivelesEducativosService);

    NivelesEducativosService.$inject = ['$resource'];

    function NivelesEducativosService ($resource) {
        var resourceUrl =  'apo/nivelesEducativos';

        return $resource(resourceUrl, {}, {
        	'getAll': { method: 'GET', isArray: true}
        });
    }
})();
